// Shared contact constants
export const WHATSAPP_NUMBERS = [
  { display: "+91 9140773912", digits: "919140773912" },
  { display: "+91 9194123633", digits: "919194123633" },
];

export const EMAIL = "UrbanVistaWeb@outlook.com";

// Primary number used by the floating button default href (e.g. on platforms that
// don't open the popover menu, like middle-click / right-click "open link").
export const PRIMARY_WHATSAPP = WHATSAPP_NUMBERS[0];
